$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});
const heightInput = `<label for="unitValue" id="unitLabel">Altura atual:</label>
                        <div class="range-control">
                            <input type="range" class="unitRange" name="unitValue" min="10" max="150" step="1" value="10">
                            <div class="value">
                                <span></span>
                            </div>                            
                        </div>
                        <div class="range-infos">
                                <div class="first-label">60 cm</div>
                                <div class="second-label">150 cm</div>
                        </div>`;
const weightInput = `<label for="unitValue" id="unitLabel">Peso atual:</label>
                        <div class="birth-input">
                            <select name="unitValue[kg]">
                                ${getWeightOptions("kg", 31, 2, 1)}
                            </select>

                            <span class="weight-calc">Kg</span>

                            <select name="unitValue[g]">
                                ${getWeightOptions("g", 1000, 0, 100)}
                            </select>
                            <span class="weight-calc">Gramas</span>
                        </div>


`;

function getWeightOptions(unit, maxValue, startFrom, step) {
    let options = "";
    for (let i = startFrom; i < maxValue; i += step) {
        options += `<option value=${i}>${i} ${unit}</option>`;
    }

    return options;
}


function printErrorMsg(msg) {
    $(".print-error-msg").find("ul").html("");
    $(".print-error-msg").css("display", "block");
    $.each(msg, function (key, value) {
        $(".print-error-msg")
            .find("ul")
            .append("<li>" + value + "</li>");
    });
}
function yearDiff(dt1, dt2) {
    var diffYear = (dt2.getTime() - dt1.getTime()) / 1000;
    diffYear /= 60 * 60 * 24;
    return Math.abs(Math.round(diffYear / 365.25));
}
function getAgeText(currentDate, birthDate) {
    let diff = moment.preciseDiff(currentDate, birthDate, true);
    let monhtsMessage = diff.months > 0 ? `e ${diff.months} meses` : "";

    return `${diff.years} Ano(s) ${monhtsMessage} `;
}
window.components.calculatorForm = {
    selector: "section[calculator-form]",

    init: function () {
        this.events();
    },

    handleUnitTypeChange: function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $("#unitInputContainer").html("");
        switch (e.target.value) {
            case "height":
                $("#unitInputContainer").html(heightInput);
                $("body")
                    .find("input[type=range]")
                    .first()
                    .on(
                        "input",
                        window.components.calculatorForm.onInputRangeChange
                    );
                $("body").find("input[type=range]").first().trigger("input");
                break;
            case "weight":
                $("#unitInputContainer").html(weightInput);
        }
    },
    handleBirthDayChange: function (e) {
        $(".birth-calc").text("");
        let currentDate = new Date();
        let birthDate = new Date(e.target.value);
        if (birthDate <= currentDate) {
            let age = yearDiff(currentDate, birthDate);

            if (age >= 0 && age <= 5) {
                $(".birth-calc").text(getAgeText(currentDate, birthDate));
            } else {
                alert("A idade deve estar entre 0 e 5 Anos");
                $("#birthdate").val("");
            }
        } else {
            $("#birthdate").val("");
        }
    },

    events: function () {
        $(this.selector).find("button.calc").on("click", this.onClickCalc);
        $(this.selector)
            .find("input[name=birthdate]")
            .on("focusout", this.handleBirthDayChange);
        $(this.selector)
            .find("input[type=radio][name=unit]")
            .on("change", this.handleUnitTypeChange);

        $(this.selector).find("input[type=radio][name=unit]").first().change();
    },

    onClickCalc: function (e) {
        e.preventDefault();
        const formData = $("#formCalculate").serialize();

        $.post("calculadora/calculate", formData, function (data) {
            $("#resultMessage").html(data.message);
            $("#explanation").html(data.explanation);
            $("#graph").html(data.graph);
        }).fail((err) => {
            if (err.status === 422) {
                const { errors } = err.responseJSON;
                printErrorMsg(errors);
            }
        });

        $(window.components.calculatorForm.selector).addClass("calculated");
    },

    onInputRangeChange: function (e) {
        const options = {
            min: $(e.target).attr("min"),
            max: $(e.target).attr("max"),
            cur: $(e.target).attr("step"),
        };
        const percentage =
            ((e.target.value - options.min) / (options.max - options.min)) *
            100;
        
            $(e.target).css(
                "background",
                `linear-gradient(to right, #CD001A, #CD001A ${percentage}%, #F0ECE2 ${percentage}%, #F0ECE2 100%)`
            );
            $(e.target)
                .siblings(".value")
                .find("span")
                .html(`${e.target.value} cm`);
    },
};
